import script from "./MarketData.vue?vue&type=script&setup=true&lang=js"
export * from "./MarketData.vue?vue&type=script&setup=true&lang=js"

import "./MarketData.vue?vue&type=style&index=0&id=1837f025&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1837f025"]])

export default __exports__